import _ from "lodash";
import { fetch } from "../lib/network";
import AppSettings from "../config";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { getEmployees, getEmployee, getEmployeeCrmPermissions, getEmployeeCePermissions } from "../actions/employees";

export const fetchGetEmployees = (dispatch: any) => (key: any, query?: any) => dispatch(getEmployees(query));
export const fetchGetEmployee = (dispatch: any) => (key: any, id: string) => dispatch(getEmployee(id));
export const fetchGetEmployeeCrmPermissions = (dispatch: any) => (key: any, id: string) =>
  dispatch(getEmployeeCrmPermissions(id));
export const fetchGetEmployeeCePermissions = (dispatch: any) => (key: any, id: string) =>
  dispatch(getEmployeeCePermissions(id));

export const useEmployees = (params?: any) => {
  const dispatch = useDispatch();
  const employeesQuery = useQuery(["employees", params], fetchGetEmployees(dispatch));
  const employeesData = useMemo(() => _.get(employeesQuery.data, "payload.data", []), [employeesQuery.data]);
  return {
    query: employeesQuery,
    data: employeesData,
  };
};

export const postOutOfOffice = (networkHeaders: any, id: string) => (body: any) =>
  fetch(`${AppSettings.EMPLOYEES_API_URL}/${id}/ooo`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: body }),
  });

export const getInspectors = (networkHeaders: any, inspectionTypeId: string) => () =>
  fetch(`${AppSettings.EMPLOYEES_API_URL}/${inspectionTypeId}/inspectors`, {
    method: "GET",
    headers: networkHeaders,
  }).then(async (response) => {
    if (response.ok) {
      return await response.json();
    }
    throw response;
  });
